import { appendAuthTokenToQuery } from './append-auth-token-to-query';
import { updateAuthToken } from './update-auth-token';

export const updateAndAppendAuthTokenToQuery = async (url: string): Promise<string> => {
  await updateAuthToken();
  return appendAuthTokenToQuery(url);
};
